module.exports = __webpack_public_path__ + "static/media/bike.6ec113cc.png";